const initialState = {
    isModalOpen: false,
    modalName: '',
};

const modalReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'TOGGLE_MODAL':
            return {
                ...state,
                isModalOpen: !state.isModalOpen,
                modalName: action.payload.modalName,
                modalData: action.payload.modalData,
            };
        case 'CLOSE_MODAL':
            return {
                ...state,
                isModalOpen: false,
                modalName: '',
                modalData: null,
            };
        default:
            return state;
    }
};

export default modalReducer;
